module.exports = __webpack_public_path__ + "static/img/Hulk.3d0cdc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Hulk.jpg
// module id = Q3gL
// module chunks = 1